import { IndividualExtendedModel, CompanyExtendedModel, DocumentOwnerType } from '@spa/api';
export class DocumentHelper {

    static getUserIdDependingOnClientType(client: IndividualExtendedModel | CompanyExtendedModel) {

        return (client instanceof IndividualExtendedModel) ?
        (client as IndividualExtendedModel).userCorrelationId : client.id;
    }

    static getDocumentOwnerTypeOnClientType(client: IndividualExtendedModel | CompanyExtendedModel): DocumentOwnerType {
        return (client instanceof IndividualExtendedModel) ?
        DocumentOwnerType.OwnerIsIndividual : DocumentOwnerType.OwnerIsCompany;
    }
}
